{
  "library": {
    "categoryView": "Category",
    "filter": {
      "owner": "Owner",
      "tags": "Tags",
      "tiers": "Tiers"
    },
    "header": "Library",

    "noDocumentVersionsFound": "No document versions found",
    "filterByTitlePlaceholder": "Filter by title...",
    "columns": "Columns",
    "noResults": "No results.",
    "filters": {
      "before": "Before",
      "after": "After",
      "selectedCount": "{{count}} selected",
      "invalidDateRange": "After date must be before or equal to Before date",
      "isBefore": "is before",
      "isAfter": "is after",
      "isBetween": "is between",
      "equals": "is",
      "includes": "is one of",
      "notSet": "not set",
      "nullLabel": {
        "adoptedAt": "Not adopted",
        "reviewFrom": "No review from",
        "reviewTo": "No review to"
      }
    },
    "pagination": {
      "navigation": "Pagination",
      "previousPage": "Go to previous page",
      "previous": "Previous",
      "nextPage": "Go to next page",
      "next": "Next",
      "morePages": "More pages",
      "showCount": "Show {{count}}"
    },
    "onboardDocuments": {
      "header": "Onboard documents",
      "subtitle": "Follow the guide to onboard your documents to North House",
      "steps": {
        "upload": {
          "title": "Upload documents",
          "description": "Upload multiple documents",
          "cardTitle": "Upload documents",
          "cardDescription": "Select the governance documents you want to onboard.",
          "clickOrDrag": "Click or drag files to upload",
          "addMore": "Add more files",
          "continue": "Continue with {{count}} file(s)",
          "unsupportedType": "\"{{name}}\" has an unsupported file type",
          "fileTooLarge": "\"{{name}}\" exceeds the 50 MB size limit",
          "duplicateFiles": "Already uploaded files were skipped"
        },
        "configure": {
          "title": "Set location in your framework",
          "description": "Place each document in category and tier",
          "cardTitle": "Set title, tier, and category",
          "cardDescription": "Configure the core metadata for each uploaded document."
        },
        "fields": {
          "title": "Finish the onboarding",
          "description": "Set other fields and publish the documents in North House",
          "cardTitle": "Set additional fields",
          "cardDescription": "Set owner, publisher, and other fields, then publish your documents."
        },
        "completion": {
          "cardTitle": "Documents onboarded",
          "cardDescription": "Your documents have been successfully onboarded."
        }
      }
    }
  }
}
